module.exports = __webpack_public_path__ + "static/pay-error.50ac5dd8.png";